import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToTopProps {
  children?: React.ReactNode;
}

/**
 * ScrollToTop component that wraps children and scrolls to top
 * on every route change.
 */
const ScrollToTop: React.FC<ScrollToTopProps> = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'auto' // Use 'auto' or 'smooth' instead
  });
}, [pathname]);

  return <>{children}</>; // Render children
};

export default ScrollToTop;
